export function update(id: string, child: any) {
  const el = document.getElementById(id);
  if (!el || el === undefined) {
    return;
  }
  while (el.lastChild) {
    el.removeChild(el.lastChild);
  }
  el.appendChild(child);
}

export function div(...node_class: string[]): HTMLDivElement {
  const d = document.createElement("div");
  d.classList.add(...node_class);
  return d;
}

export function span(...node_class: string[]): HTMLSpanElement {
  const s = document.createElement("span");
  s.classList.add(...node_class);
  return s;
}

export function anchor(...node_class: string[]): HTMLAnchorElement {
  const a = document.createElement("a");
  a.classList.add(...node_class);
  return a;
}

export function input(...node_class: string[]): HTMLInputElement {
  const i = document.createElement("input");
  i.setAttribute("type", "text");
  i.classList.add(...node_class);
  return i;
}

export function textarea(...node_class: string[]): HTMLTextAreaElement {
  const el = document.createElement("textarea");
  el.classList.add(...node_class);
  return el;
}

export function inputSubmit(...node_class: string[]): HTMLInputElement {
  const i = input(...node_class);
  i.setAttribute("type", "submit");
  return i;
}

export function inputButton(...node_class: string[]): HTMLInputElement {
  const i = input(...node_class);
  i.setAttribute("type", "button");
  return i;
}

export function form(...node_class: string[]): HTMLFormElement {
  const f = document.createElement("form");
  f.classList.add(...node_class);
  return f;
}

export function h1(...node_class: string[]): HTMLHeadingElement {
  const el = document.createElement("h1");
  el.classList.add(...node_class);
  return el;
}

export function h2(...node_class: string[]): HTMLHeadingElement {
  const el = document.createElement("h2");
  el.classList.add(...node_class);
  return el;
}

export function p(...node_class: string[]): HTMLParagraphElement {
  const el = document.createElement("p");
  el.classList.add(...node_class);
  return el;
}

export function button(...node_class: string[]): HTMLButtonElement {
  const el = document.createElement("button");
  el.classList.add(...node_class);
  return el;
}

export function table(...node_class: string[]): HTMLTableElement {
  const el = document.createElement("table");
  el.classList.add(...node_class);
  return el;
}

export function tablehead(...node_class: string[]): HTMLTableSectionElement {
  const el = document.createElement("thead");
  el.classList.add(...node_class);
  return el;
}

export function tablerow(...node_class: string[]): HTMLTableRowElement {
  const el = document.createElement("tr");
  el.classList.add(...node_class);
  return el;
}

export function tabledata(...node_class: string[]): HTMLTableDataCellElement {
  const el = document.createElement("td");
  el.classList.add(...node_class);
  return el;
}

export function tableheadcell(...node_class: string[]): HTMLTableHeaderCellElement {
  const el = document.createElement("th");
  el.classList.add(...node_class);
  return el;
}

export function br(...node_class: string[]): HTMLBRElement {
  const el = document.createElement("br");
  el.classList.add(...node_class);
  return el;
}

export function textnode(text: string): Text {
  return document.createTextNode(text);
}